module.exports = __webpack_public_path__ + "img/df.2087da7b.png";